module.exports = __webpack_public_path__ + "img/5.59c92187.png";